/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'

import {IInputMutation, useDispatchesStore} from '../store/dipatches'
import {KTIcon} from '../../_metronic/helpers'
import {Button} from 'react-bootstrap'
import moment from 'moment'
import {useNetworkStatus} from '../hooks/useNetworkStatus'

export const DropdownDisparches: FC<{
  updateDispatchPendig: (disptach: IInputMutation) => void
  onOpen: () => void
}> = ({updateDispatchPendig, onOpen}) => {
  const isOnline = useNetworkStatus()
  const dispatches = useDispatchesStore((s) => s.dipatches)
  const toggleSending = useDispatchesStore((s) => s.toggleSending)
  const updateTotalDispatches = useDispatchesStore((s) => s.updateTotalDispatches)

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
      data-kt-menu='true'
    >
      <div
        className='d-flex flex-column bgi-no-repeat rounded-top'
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(79,41,158,1) 48%, rgba(72,26,167,1) 99%)`,
        }}
      >
        <h3 className='text-white fw-bold px-9 mt-10 mb-6'>
          Despachos <span className='fs-8 opacity-75 ps-3'>{dispatches.length} pendientes</span>
        </h3>
        |
      </div>

      <div>
        <div>
          <div className='scroll-y mh-325px my-5 px-8'>
            {dispatches.map((oneDispatch, idx) => (
              <div key={`alert${idx}`} className='d-flex flex-stack py-4'>
                <div className='d-flex align-items-center'>
                  <div className='symbol symbol-35px me-4'>
                    <span className={clsx('symbol-label', `bg-light-warning`)}>
                      {' '}
                      <KTIcon iconName='send' className={`fs-2 text-warning`} />
                    </span>
                  </div>

                  <div className='mb-0 me-2'>
                    <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bolder'>
                      {oneDispatch.plate}
                    </a>
                    <div className='text-gray-400 fs-7'>
                      {moment(oneDispatch.departureTime).format('DD MMM YY - hh:mm A')}
                    </div>
                  </div>
                </div>
                <button
                  style={{border: 0, backgroundColor: 'transparent', padding: 0, margin: 0}}
                  title='Ver despacho'
                  onClick={() => {
                    updateDispatchPendig(oneDispatch)
                    onOpen()
                  }}
                >
                  <i className='bi bi-eye text-info' />
                </button>
              </div>
            ))}
            {dispatches.length === 0 && (
              <div className='d-flex flex-stack py-4'>
                <div className='d-flex align-items-center'>
                  <div className='symbol symbol-35px me-4'>
                    <span className={clsx('symbol-label', `bg-light-warning`)}>
                      {' '}
                      <KTIcon iconName='directbox-default' className={`fs-2 text-warning`} />
                    </span>
                  </div>

                  <div className='mb-0 me-2'>
                    <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bolder'>
                      No hay despachos pendientes
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>

          {dispatches.length > 0 && isOnline && (
            <div className='py-3 text-center border-top'>
              <Button
                className='btn btn-color-white btn-info'
                onClick={() => {
                  updateTotalDispatches(dispatches.length)
                  toggleSending(true)
                }}
              >
                Despachar <KTIcon iconName='cloud-add' className='fs-5' />
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
